export default __webpack_public_path__ + "static/media/unsere_haeuser_web-lg@2x.26822b76.jpg";